<template>
  <b-modal
    title="Dispositivo"
    size="md"
    id="view_device"
    no-close-on-backdrop
    no-close-on-esc
    :busy="loading"
    hide-footer
    @show="evOnShow"
    @shown="evOnShown"
    @hide="evOnHide"
  >
    <b-form @submit.prevent="evOnSubmit">
      <b-row>
        <b-col>
          <LabelRequiredField label="Nome" />
          <b-input type="text" ref="autofocus" v-model="name"></b-input>
          <small class="form-text text-muted">Exemplo: Computador Sala 1</small>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <LabelRequiredField label="Código" />
          <b-input type="text" v-model="code"></b-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-checkbox :value="1" :unchecked-value="0" v-model="status">
            LIBERADO
          </b-checkbox>
        </b-col>
      </b-row>
      <WarningRequiredFields />
      <ErrorsMessages :errors="errors" />
      <b-row align-h="between">
        <b-col cols="auto">
          <v-btn class="v-primary" @click="$bvModal.hide('view_device')">
            <span class="fa fa-arrow-left"></span> Voltar
          </v-btn>
        </b-col>
        <b-col cols="auto">
          <v-btn class="v-danger" @click="remove">
            <span class="fa fa-trash"></span>
            Excluir
          </v-btn>
          <v-btn type="submit" class="v-success">
            <span class="fa fa-check"></span>
            Salvar
          </v-btn>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import ErrorsMessages from "../../components/ErrorsMessages";
import WarningRequiredFields from "../../components/WarningRequiredFields";
import LabelRequiredField from "../../components/LabelRequiredField";
import api from "../../../services/api";
import toast from "../../../components/ToastNotification";

export default {
  name: "ViewDevice",

  components: {
    ErrorsMessages,
    WarningRequiredFields,
    LabelRequiredField,
  },

  props: {
    device: [Object, null],
  },

  data() {
    return {
      errors: [],
      loading: false,

      rest_home_id: "",

      name: "",
      code: "",
      status: 1,
    };
  },

  created() {
    const { rest_home_id } = this.$attrs;
    this.rest_home_id = rest_home_id;
  },

  watch: {
    device() {
      this.name = this.device ? this.device.name : "";
      this.code = this.device ? this.device.code : "";
      this.status = this.device ? this.device.status : 1;

      if (this.device) this.$bvModal.show("view_device");
    },
  },

  methods: {
    async evOnShow() {
      this.errors = [];
      this.loading = false;
    },

    async evOnShown() {
      this.$refs.autofocus.focus();
    },

    async evOnHide() {
      this.$emit("close");
    },

    async evOnSubmit() {
      try {
        this.loading = true;

        const data = {
          rest_home_id: this.rest_home_id,
          id: this.device.id,
          name: this.name,
          code: this.code,
          status: this.status,
        };
        let response = await api.patch("/admin/rest-home/device", data);
        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$emit("updated");
          this.$bvModal.hide("view_device");
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async remove() {
      try {
        this.loading = true;

        const params = { rest_home_id: this.rest_home_id, id: this.device.id };
        const response = await api.delete("/admin/rest-home/device", {
          params,
        });
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$emit("updated");
          this.$bvModal.hide("view_device");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>